var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoomConfig(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 62,
    viewBox: "0 0 80 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4791 41.2339H40.6461V33.0813H31.8853C27.0915 33.0813 23.1404 36.6276 22.4797 41.2339H22.4791ZM15.8418 39.028C19.5073 39.028 22.4791 36.0562 22.4791 32.3907C22.4791 28.7271 19.5086 25.7574 15.8418 25.7574C12.1808 25.7574 9.20846 28.7271 9.20846 32.3907C9.20846 36.0562 12.1808 39.028 15.8418 39.028ZM5.30291 21.1026H0.761963V61.663H5.30291V52.3613H40.6461V43.9586H5.30291V21.1026ZM79.7502 42.5959C79.7502 37.341 75.488 33.0806 70.2343 33.0806H43.3697V52.3602H75.2083V61.6619H79.7492L79.7467 42.5947L79.7502 42.5959ZM49.5999 6.37204H43.37V0.142822H37.1433V6.37204H30.9134V12.5969H37.1433V18.83H43.37V12.5969H49.5999V6.37204Z",
    fill: "#616161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomConfig);
export default __webpack_public_path__ + "static/media/RoomConfig.e12d91680320aaf965ec74a043d95ad7.svg";
export { ForwardRef as ReactComponent };